import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";
import PlayerValueOverTimeChartWrap from "./PVContent/PlayerValueOverTime/PlayerValueOverTimeChartWrap";
import NRPFChartWrap from "./PVContent/NRPF/NRPFChartWrap";
const PV = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <>
            <PlayerValueOverTimeChartWrap />
            <NRPFChartWrap />
          </>
        )}
      </Box>
    </>
  );
};

export default PV;
